import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/material.module";

@Component({
  selector: 'app-patient',
  standalone: true,
  imports: [
    MaterialModule,
    TranslateModule
  ],
  templateUrl: './confirmation-date.component.html',

})
export class confirmationDateDialog {
  constructor(
    private dialogRef: MatDialogRef<confirmationDateDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) { }

  onConfirm(): void {
    this.dialogRef.close("OK");
  }
}